export default __webpack_public_path__ + "2392ac1e45bfb07b8ed14f1da2aec6b0.jpg";